import { render, staticRenderFns } from "./editInkhubMonthly.vue?vue&type=template&id=36d556eb&scoped=true"
import script from "./editInkhubMonthly.vue?vue&type=script&lang=js"
export * from "./editInkhubMonthly.vue?vue&type=script&lang=js"
import style0 from "./editInkhubMonthly.vue?vue&type=style&index=0&id=36d556eb&lang=scss&scoped=true"
import style1 from "./editInkhubMonthly.vue?vue&type=style&index=1&id=36d556eb&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d556eb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-manage/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36d556eb')) {
      api.createRecord('36d556eb', component.options)
    } else {
      api.reload('36d556eb', component.options)
    }
    module.hot.accept("./editInkhubMonthly.vue?vue&type=template&id=36d556eb&scoped=true", function () {
      api.rerender('36d556eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/other/editInkhubMonthly.vue"
export default component.exports